import Colors from '@stripe-internal/sail/lib/colors';

const componentToHex = (component: number) => {
  const hex = component.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

const rgbToHex = ([r, g, b]: [number, number, number]) => {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

export const darkenColor = (color: string, opacity: number) => {
  const baseRGB = Colors.hexToRgb(color.replace(/^#/, ''));
  const newColor = Colors.darkenBy(baseRGB, opacity);
  return rgbToHex(newColor);
};

export const contrastingTextColor = (
  backgroundColor: string,
  lightTextColor: string,
  darkTextColor: string,
) => {
  const [r, g, b] = Colors.hexToRgb(backgroundColor.replace(/^#/, ''));
  const brightness = Colors.brightness([r, g, b]);

  if (brightness > 50) {
    return darkTextColor; // bright colors -> dark text
  } else {
    return lightTextColor; // dark colors -> light text
  }
};
